import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import moment from "moment";

function VehicleModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
  stations = [],
}) {
  return (
    <Modal
      title={isUpdate ? "Update Vehicle" : "Add Vehicle"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={(values) => {
          values.dock_station =
            values.dock_station?.value || values.dock_station;
          onSave(values);
        }}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
                mfg_date: data.mfg_date ? moment(data.mfg_date) : null,
                dock_station: data.dock_station
                  ? {
                      value: data.dock_station._id,
                      label: data.dock_station.station_number,
                    }
                  : null,
              }
            : {
                is_active: true,
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Vehicle Number"
              name="vehicle_number"
              rules={[
                {
                  required: true,
                  message: "Please input Vehicle Number",
                },
              ]}
            >
              <Input placeholder="Vehicle Number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please input Type",
                },
              ]}
            >
              <Input placeholder="Type" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="MFG Date" name={"mfg_date"}>
              <DatePicker placeholder="MFG Date" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="IMEI Number"
              name={"imei_number"}
              rules={[
                {
                  required: true,
                  message: "Please input IMEI Number",
                },
              ]}
            >
              <Input placeholder="IMEI Number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Price / Minute"
              name={"price_per_min"}
              rules={[
                {
                  required: true,
                  message: "Please input Price / Minute",
                },
              ]}
            >
              <Input placeholder="Price / Minute" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Status"
              name="is_active"
              rules={[
                {
                  required: true,
                  message: "Please select Status",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Active</Radio>
                <Radio value={false}> In-Active </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              label="Dock Station"
              name="dock_station"
              rules={[
                {
                  required: true,
                  message: "Please select dock station",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search and Select Station Number"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={stations.map((item) => ({
                  value: item._id,
                  label: item.station_number,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default VehicleModal;
